/* eslint-disable import/first */
// polyfill webpack require.ensure
if (typeof require.ensure !== 'function') require.ensure = function (deps, cbFn) {
  return cbFn(require);
};
export default (function () {
  return {
    path: 'try',
    getIndexRoute: function getIndexRoute(location, callback) {
      require.ensure([], function (require) {
        callback(null, {
          component: require('containers/CmsPage/CmsPage').CmsPage
        });
      }, 'try');
    },
    getChildRoutes: function getChildRoutes(location, callback) {
      require.ensure([], function (require) {
        callback(null, [{
          path: '*',
          component: require('containers/CmsPage/CmsPage').CmsPage
        }]);
      }, 'try');
    }
  };
});